import { selectSearchEntityIdsByCurrentQueryId } from 'ducks/searches/selectors'
import { doPreloadTickets } from './doPreloadTickets'

export const doPreloadTicketsForCurrentQueryId = () => (dispatch, getState) => {
  const ticketIds = selectSearchEntityIdsByCurrentQueryId(getState())

  return dispatch(doPreloadTickets({ ticketIds }))
}
